module.exports = __webpack_public_path__ + "assets/img/23.01c82d3b.png";